import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function FeetFront() {
	return (
		<g>
			<path className="fill fill--alt foot foot--back foot--outside" d="M330.2015686,292.6184998
				c-2.2128906,21.534668-2.7739258,44.2214355-2.078125,67.7861328l-0.0047913,0.0203857
				c0,9.9409485,9.1488037,14.3233032,27.0380859,14.3233032c17.8893127,0,27.0429077-4.3823547,27.0429077-14.3233032v-0.0204468
				c0-41.6942749,0-67.7858887-40.3345337-67.7858887L330.2015686,292.6184998z" />
			<path className="fill fill--alt foot foot--front foot--inside" d="M246.1427612,292.6184998
				c2.2128906,21.534668,2.7739258,44.2214355,2.078125,67.7861328l0.004776,0.0203857
				c0,9.9409485-9.1487732,14.3233032-27.0380859,14.3233032s-27.0429077-4.3823547-27.0429077-14.3233032v-0.0204468
				c0-41.6942749,0-67.7858887,40.334549-67.7858887L246.1427612,292.6184998z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/FeetFront.js